
import { Base } from '../base-component';
import CheckEligibility from '../../services/check-eligibility.service';
import { AnalyticsService } from '../../services/analytics.service';

import axios, {
	AxiosResponse,
	AxiosPromise,
	AxiosRequestConfig
} from 'axios';

import './form-check-eligibility-business-strata-account.component.scss';

import * as $ from 'jquery';

export class FormCheckEligibilityBusinessStrataAccount extends Base {

	// service
	checkEligibility: any;

	// elements
	form: HTMLFormElement;
	buttonSubmit: Element[];
	radioStrata: Element[];
	closeButton: Element;

	// containers
	containerFields: Element;
	containerButtons: Element;
	containerNote: Element;
	containerThankYou: Element;
	containerInvalid: Element;
	containerValid: Element;
	containerModal: Element;
	containerLoader: any;

	// values
	valuesJson: any;
	valueModalId: any;

	// storage
	eligibilityStorage: any;


	constructor(element: Element) {
		super(element);
	}

	init() {

		this.checkEligibility = new CheckEligibility();
		this.form = this.element.querySelector('form') as HTMLFormElement;

		this.radioStrata = Array.from(this.element.querySelectorAll('.js-trust-service-provider__radio'));
		this.buttonSubmit = Array.from(this.element.querySelectorAll('.js-check-eligibility-submit__button'));

		this.containerFields = this.element.querySelector('.form__fields--container');
		this.containerThankYou = this.element.querySelector('.form__thankyou--container');	
		this.containerInvalid = this.element.querySelector('.js-invalid-container');
		this.containerValid = this.element.querySelector('.js-valid-container');
		this.containerLoader = this.element.querySelector('.form__loader--container');

		this.containerModal = this.element.closest('.form-container');
		this.closeButton = this.containerModal.querySelector('.js-apply-now-modal-close');	

		this.valuesJson = {
			operation: "open",
			category: "business",
			leadType: "CallBack_TCSP",
			leadCTA: "CHECK ELIGIBILITY",
			eligibilityCTA: "Call Me Back",
			leadStatus: "Open",
			eligibilityFormId: "",
			clientTCSP: "",
			productName: "",
			pageUrl: ""
		}

	}

	bindEvents() {

		// radio buttons- private client
		this.radioStrata.map((item) => item.addEventListener('click', (event) => {			
			const element: any = event.target;			

			if (element.value == "yes") {
				this.valuesJson.clientTCSP = 'Y';
			} else {
				this.valuesJson.clientTCSP = 'N';
			}	
			
		}));

		// submit button
		this.buttonSubmit.map((item) => item.addEventListener('click', (event) => {
						
			let formModal = this.element.closest('.js-apply-now-modal');
			this.valueModalId = formModal.getAttribute('id');

			const formFields: any = this.containerFields.querySelectorAll('input, select');
			let validation: any = this.validationService.validate(formFields);

			if(validation.valid){
				
				if(this.valuesJson.clientTCSP !== '') {
				
					if(this.valuesJson.clientTCSP === 'Y') {
			
						this.applyFilters('callmeback', this.valueModalId);
	
					}else{
							
						this.containerFields.classList.add('hidden');
						this.containerThankYou.classList.add('active');
						this.containerInvalid.classList.add('active');
						this.checkEligibility.changeButtons('contactus', this.valueModalId);	
	
					}

				}else{

					this.radioStrata.map((item, index) => {
						let parent = item.closest('.form__group');
						parent.classList.add('form__group--error');
					});

				}

			}else{
	
				this.containerInvalid.classList.add('active');
				this.containerThankYou.classList.add('active');
				this.containerFields.classList.add('hidden');
				this.checkEligibility.changeButtons('contactus', this.valueModalId);

			}

		}));

		// close button - reset form
		this.closeButton.addEventListener('click', (event) => {
			
			this.containerValid.classList.remove('active');
			this.containerInvalid.classList.remove('active');

			this.containerValid.classList.add('form-check-eligibility-seafarer-bank-account--hidden');
			this.containerInvalid.classList.add('form-check-eligibility-seafarer-bank-account--hidden');
			
		});

		$(document).on('click', '.js-apply-now-modal-open', (event) => {
			let element = event.target;
			let type = $(element).attr('data-productname');
			let modal = $(element).attr('data-modal');
			let data = $(element).attr('data-text');
			let dataArray = data.split(" | ");
			let dataNewFormName = "checkeligibility | wealth business | " + type;
			this.form.setAttribute('data-frmcontainer', dataNewFormName);
			this.valuesJson.pageUrl = window.location.href;
			if(type){
				this.valuesJson.productName = type;
			}
			if(modal){
				this.valuesJson.eligibilityFormId = modal;
			}
			this.formstart();
		});

	}

	applyFilters(type, modalId){	

		let typeValue = type;
		let modalIdValue = modalId;

		let containerLoader = this.containerLoader;
		let containerThankyou = this.containerThankYou;
		let containerFields = this.containerFields;
		let containerValid = this.containerValid;
		let containerInvalid = this.containerInvalid;
		let checkEligibility = this.checkEligibility;

		containerFields.classList.add('hidden');
		containerLoader.classList.add('active');
		
		// variables
		let response = 'invalid';

		// fields
		let operation: any = this.valuesJson.operation;	
		let category: any = this.valuesJson.category;		
		let leadType: any = this.valuesJson.leadType;	
		let leadCTA: any = this.valuesJson.leadCTA;
		let eligibilityCTA: any = this.valuesJson.eligibilityCTA;
		let leadStatus: any = this.valuesJson.leadStatus;
		let eligibilityFormId: any = this.valuesJson.eligibilityFormId;
		let clientTCSP: any = this.valuesJson.clientTCSP;
		let productName: any = this.valuesJson.productName;
		let pageUrl: any = this.valuesJson.pageUrl;

		// build string
		let postData = '';
		if (operation) {
			postData += 'operation=' + operation + '&';
		}
		if (category) {
			postData += 'category=' + category + '&';
		}
		if (leadType) {
			postData += 'leadType=' + leadType + '&';
		}
		if (leadCTA) {
			postData += 'leadCTA=' + leadCTA + '&';
		}
		if (eligibilityCTA) {
			postData += 'eligibilityCTA=' + eligibilityCTA + '&';
		}
		if (leadStatus) {
			postData += 'leadStatus=' + leadStatus + '&';
		}
		if (eligibilityFormId) {
			postData += 'eligibilityFormId=' + eligibilityFormId + '&';
		}
		if (clientTCSP) {
			postData += 'clientTCSP=' + clientTCSP + '&';
		}
		if (productName) {
			postData += 'productName=' + productName + '&';
		}
		if (pageUrl) {
			postData += 'pageUrl=' + pageUrl + '&';
		}

		// config
		let analyticsService = new AnalyticsService();
		let url = "/services/SubmitWINLead.jsp";
		const config = {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				"Access-Control-Allow-Origin": "*",
				'X-Requested-With': 'XMLHttpRequest'
			}
		}

		// service
		axios.post(url, postData, config).then(function (response) {

			if (response.data === 'invalid') {
				analyticsService.dtmRecordSiteError('noerrorcode|invalid fields|' + url);
				containerValid.classList.remove('active');	
				containerLoader.classList.remove('active');
				containerFields.classList.remove('hidden');
				checkEligibility.changeButtons(typeValue, modalId, '');
				
			} else {

				response = response.data;
				containerLoader.classList.remove('active');

				containerInvalid.classList.remove('active');	
				containerValid.classList.add('active');	
				containerThankyou.classList.add('active');
				containerFields.classList.add('hidden');

				checkEligibility.changeButtons('callmeback', modalIdValue, response);
			}
			analyticsService.dtmFormComplete('complete', 'Submitted');

		}).catch(function (response) {
			// service failed
			analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);

		});

	}

	// reset form
	resetForm() {
		if (this.form) {
			this.form.reset();
			let formContainerLoader = this.element.querySelector('.form__loader--container');
			let formContainerFields = this.element.querySelector('.form__fields--container');
			let formContainerThankyou = this.element.querySelector('.form__thankyou--container');
			formContainerThankyou.classList.remove('active');
			formContainerFields.classList.remove('hidden');
		}
	}

	formstart() {

		let dataNewFormName = "checkeligibility | wealth business | " + this.valuesJson.productName;
		this.analyticsService.dtmFormNameUpdate(dataNewFormName);
		this.analyticsService.dtmAllowFormRefresh();

	}

}



// WEBPACK FOOTER //
// ./components/form-check-eligibility-business-strata-account/form-check-eligibility-business-strata-account.component.ts